<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col m-0 p-0">
                <audio-buttons-segment
                    v-model="sharedState.favCurrentPage.data"
                    :audio-items="items"
                    :audio-items-array="itemsArray"
                    :button-type="minibuttonType"
                ></audio-buttons-segment>
            </div>
        </div>
    </div>
</template>

<script>
import AudioButtonsSegment from '@/components/AudioButtonsSegment.vue'
import Global from '@/mixins/global'
import store from '../store/store'

export default {
    name: 'FavButtons',
    components: {
        AudioButtonsSegment,
    },
    mixins: [Global],
    data: function () {
        return {
            sharedState: store.favs.state,
        }
    },
    computed: {
        minibuttonType: function() {
            return store.getMiniButtonType()
        },
        items: function () {
            const favItmes = store.favs.getNowPageFavItems()
            const itemsOfItems = this.splitArrayByKey(favItmes, 'videoId')
            return itemsOfItems
        },
        itemsArray: function() {
            return store.favs.getFavItems()
        }
    },

}
</script>

